import React, { useEffect, useState } from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';
import { resolveMedia } from '../lib/media';

/**
 * Sezione = fasce logiche della grafica "MAIN PARTNERS" del pitch ufficiale.
 * Ogni voce può avere:
 *   - name: testo mostrato sotto (o fallback se logo non carica)
 *   - url: sito ufficiale (se mancante il logo non è cliccabile)
 *   - domain: dominio per logo Clearbit (facoltativo, default = url)
 *   - desc: descrizione 3 righe
 *   - mode: 'logo' (default) o 'text' per i brand senza logo Clearbit
 */
const SECTIONS = [
  {
    title: 'MAIN PARTNER',
    items: [
      {
        name: 'MAS NETWORK',
        url: 'https://www.masnetwork.it',
        domain: 'masnetwork.it',
        desc: "Partner & cliente storico di Tecniche Perfette. Agenzia di management, consulenze artistiche e produzione eventi. Fondata nel 2013 da Gianluca Coppola, oggi guidata da Mastafive.",
        mode: 'text',
      },
    ],
  },
  {
    title: 'BRAND PARTNERS',
    items: [
      { name: 'DOLLY NOIRE', url: 'https://dollynoire.com', domain: 'dollynoire.com', desc: "Streetwear italiano di culto, nato a Milano. Collezioni ispirate al mondo hip-hop, skate e urban. Partner di moda di più edizioni T.P." },
      { name: 'COPPOLELLA', url: 'https://www.coppolella.it', domain: 'coppolella.it', desc: "Brand italiano di occhiali da sole artigianali fatti a mano. Design iconico e materiali premium. Collezioni limited edition." },
      { name: 'PEPSI', url: 'https://www.pepsi.com', domain: 'pepsi.com', desc: "Bevanda globale simbolo della cultura pop. Sponsor di grandi live ed eventi musicali internazionali. Partner d'edizione T.P." },
      { name: 'TFI', url: 'https://www.tficlothing.it', domain: 'tficlothing.it', desc: "Brand streetwear italiano con attitudine urban e ribelle. Collezioni limitate e forte identità visiva. Partner di moda T.P." },
      { name: 'PUMA', url: 'https://eu.puma.com/it/it', domain: 'puma.com', desc: "Colosso mondiale dello sportswear. Collezioni lifestyle, performance e collaborazioni iconiche nel mondo hip-hop. Global brand partner." },
      { name: '5 STATE OF MIND', url: 'https://www.5stateofmind.com', domain: '5stateofmind.com', desc: "Clothing brand di Clementino. Streetwear ispirato al rap partenopeo e all'attitudine 5 stati della mente. Cult tra i freestyler." },
      { name: 'CASIO G-SHOCK', url: 'https://www.gshock.casio.com', domain: 'casio.com', desc: "Orologi resistentissimi cult della scena hip-hop globale. Collezioni limited e collaborazioni streetwear. Partner T.P." },
      { name: 'FILA', url: 'https://www.fila.com', domain: 'fila.com', desc: "Storico brand italiano di sportswear. Heritage anni '90 rilanciato nel nuovo millennio. Partner di moda di più edizioni T.P." },
    ],
  },
  {
    title: 'TV · RADIO · MEDIA',
    items: [
      { name: 'MTV', url: 'https://www.mtv.it', domain: 'mtv.it', desc: "Il canale musicale più iconico al mondo. Storico partner televisivo del T.P. con programmi dedicati a freestyle e hip-hop italiano." },
      { name: 'RAI', url: 'https://www.rai.it', domain: 'rai.it', desc: "Servizio pubblico radiotelevisivo italiano. Copertura di diverse finali T.P. e interviste dedicate al movimento freestyle." },
      { name: 'RADIO DEEJAY', url: 'https://www.deejay.it', domain: 'deejay.it', desc: "La radio ufficiale del divertimento italiano. Collaborazioni, interviste e spazi dedicati al rap e al freestyle T.P." },
      { name: 'RADIO FOR MUSIC', url: 'https://www.radioformusic.it', domain: 'radioformusic.it', desc: "Network radiofonico italiano dedicato alla musica. Storico broadcasting partner del Tecniche Perfette con format dedicati." },
      { name: 'RADIO 105', url: 'https://www.105.net', domain: '105.net', desc: "Network radio pop rock italiano. Programmi dedicati all'hip-hop, freestyle e cultura urban. Media partner T.P." },
      { name: 'REAL TIME', url: 'https://www.discoveryplus.com/it/show/real-time', domain: 'realtimetv.it', desc: "Canale TV Discovery focalizzato su intrattenimento e stili di vita. Copertura mediatica di eventi T.P." },
      { name: 'HIP HOP TV', url: 'https://www.mediaset.it', domain: 'hiphoptv.it', desc: "Canale televisivo interamente dedicato alla cultura hip-hop. Videoclip, interviste e live. Partner T.P. storico." },
      { name: 'GRP TELEVISIONE', url: 'https://www.grp.it', domain: 'grp.it', desc: "Emittente televisiva piemontese. Copertura eventi locali e finali T.P. organizzate sul territorio torinese." },
      { name: 'RETE 7', url: 'https://www.retesette.it', domain: 'retesette.it', desc: "Emittente televisiva italiana regionale. Copertura mediatica di date ed eventi T.P. sul territorio." },
      { name: 'HOT BLOCK RADIO', url: 'https://www.hotblockradio.com', domain: 'hotblockradio.com', desc: "Web radio hip-hop italiana. Programmi, freestyle session e interviste. Partner digital del T.P.", mode: 'text' },
      { name: 'BILLBOARD', url: 'https://www.billboard.com/italy', domain: 'billboard.com', desc: "La bibbia internazionale della musica. Classifiche, news e copertura globale. Media partner T.P. su scala internazionale." },
      { name: 'ROCKOL', url: 'https://www.rockol.it', domain: 'rockol.it', desc: "Testata giornalistica musicale italiana di riferimento. Recensioni, news, interviste. Media partner editoriale T.P." },
    ],
  },
  {
    title: 'RECORD LABELS · MUSIC INDUSTRY',
    items: [
      { name: 'UNIVERSAL MUSIC', url: 'https://www.universalmusic.it', domain: 'universalmusic.com', desc: "Major discografica mondiale. Collabora con T.P. nella promozione di artisti hip-hop italiani e internazionali." },
      { name: 'SONY MUSIC', url: 'https://www.sonymusic.it', domain: 'sonymusic.com', desc: "Major discografica mondiale. Partner storico per la valorizzazione di nuovi talenti del freestyle e del rap italiano." },
      { name: 'PLANET RECORDS', url: 'https://www.planetrecords.it', domain: 'planetrecords.it', desc: "Etichetta discografica indipendente italiana. Distribuzione e management di artisti hip-hop e urban. Partner industry T.P." },
      { name: 'RCA RECORDING STUDIOS', url: 'https://www.sonymusic.it/labels/rca-records', domain: 'rcarecords.com', desc: "Studio di registrazione storico del gruppo Sony. Open Days e workshop dedicati ai freestyler T.P.", mode: 'text' },
      { name: 'TEMPI DURI', url: 'https://www.instagram.com/tempiduriofficial', domain: 'tempiduri.it', desc: "Collettivo artistico e produzione musicale italiana. Attivo in scena con release e eventi live. Partner industry T.P.", mode: 'text' },
      { name: 'SAIFAM', url: 'https://www.saifam.com', domain: 'saifam.com', desc: "Gruppo discografico italiano indipendente. Dance, pop e urban. Partner distributivo di diversi progetti T.P." },
      { name: 'BM RECORDS', url: 'https://www.instagram.com/bmrecordsofficial', domain: 'bmrecords.it', desc: "Back Movement Records, etichetta fondata da Stefano Bolognesi, Mastafive e Lefty. Cuore della scena rap T.P.", mode: 'text' },
      { name: 'MASSIVO', url: 'https://www.instagram.com/massivoofficial', domain: 'massivo.it', desc: "Realtà italiana di produzione musicale e eventi live. Connessione forte con la scena hip-hop. Partner T.P.", mode: 'text' },
      { name: 'ARTIST FIRST', url: 'https://www.artistfirst.it', domain: 'artistfirst.it', desc: "Distribuzione e servizi per artisti indipendenti. Rilascio digitale, marketing, sync. Partner industry T.P." },
      { name: 'NUF RECORDS', url: 'https://www.instagram.com/nuf.records', domain: 'nufrecords.com', desc: "Etichetta indipendente italiana dedicata al rap, urban ed elettronica. Scouting e sviluppo artisti. Partner T.P.", mode: 'text' },
    ],
  },
  {
    title: 'TECH · PLATFORMS',
    items: [
      { name: 'NETFLIX', url: 'https://www.netflix.com', domain: 'netflix.com', desc: "Piattaforma streaming globale. Documentari e contenuti dedicati alla cultura hip-hop. Media partner d'eccellenza T.P." },
      { name: 'DEEZER', url: 'https://www.deezer.com', domain: 'deezer.com', desc: "Piattaforma di streaming musicale francese. Playlist dedicate al rap italiano e all'hip-hop. Partner digital T.P." },
      { name: 'RANE', url: 'https://rane.com', domain: 'rane.com', desc: "Leader mondiale del DJ gear. Mixer, controller e soluzioni professionali per la scena hip-hop. Tech partner T.P." },
      { name: 'NATIVE INSTRUMENTS', url: 'https://www.native-instruments.com', domain: 'native-instruments.com', desc: "Azienda leader nella produzione musicale digitale. Software, hardware e controller DJ/producer. Tech partner T.P." },
      { name: 'BEE BAD', url: 'https://www.beebad.it', domain: 'beebad.it', desc: 'Energy drink italiano "Bad is Better". Sponsor energetico di eventi T.P. con distribuzione live durante le finali.' },
    ],
  },
  {
    title: 'FESTIVAL · LIVE · MEDIA PARTNER',
    items: [
      { name: 'SOUNDREEF', url: 'https://www.soundreef.com', domain: 'soundreef.com', desc: "Collecting society italiana alternativa alle storiche. Royalties made easy per autori ed editori. Partner legal T.P." },
      { name: 'COOP NOVOCOOP', url: 'https://www.novocoop.it', domain: 'novocoop.it', desc: "Cooperativa di consumo del Piemonte orientale. Sostegno a iniziative culturali e sociali. Partner community T.P.", mode: 'text' },
      { name: 'IVIALI SOCIAL TV', url: 'https://www.instagram.com/iviali.socialtv', domain: 'iviali.it', desc: "Social TV italiana dedicata a musica, cultura urban e lifestyle. Copertura live di eventi T.P.", mode: 'text' },
      { name: 'LIVE NATION', url: 'https://www.livenationitalia.com', domain: 'livenation.com', desc: "Leader globale dell'organizzazione concerti. Venue, tour e grandi festival. Partner live T.P." },
      { name: 'RAPUBLIC', url: 'https://www.instagram.com/rapublic', domain: 'rapublic.it', desc: "Community e testata italiana dedicata al rap game. News, interviste, classifiche. Media partner editoriale T.P.", mode: 'text' },
      { name: 'SOTTODICIOTTO FILM FESTIVAL', url: 'https://www.sottodiciottofilmfestival.it', domain: 'sottodiciottofilmfestival.it', desc: "Festival cinematografico dedicato al pubblico under 18. Anteprime, workshop e incontri. Partner culturale T.P." },
      { name: 'BUSFORFUN', url: 'https://www.busforfun.com', domain: 'busforfun.com', desc: "Servizio di trasporto verso eventi e festival. Bus dedicati per raggiungere le date T.P. in tutta Italia." },
      { name: 'GRU VILLAGE', url: 'https://www.gruvillage.com', domain: 'gruvillage.com', desc: "Festival estivo torinese presso Parco Commerciale Le Gru. Concerti, food e cultura urban. Partner live T.P." },
      { name: 'FLOWERS FESTIVAL', url: 'https://www.flowersfestival.it', domain: 'flowersfestival.it', desc: "Festival musicale di Collegno (TO) con headline internazionali. Venue storica di date T.P." },
      { name: 'VERDI RAP', url: 'https://www.instagram.com/verdirap', domain: 'verdirap.it', desc: "Realtà rap italiana indipendente. Community, release e live. Partner scene T.P.", mode: 'text' },
      { name: 'INTL LIVE BOOKING', url: 'https://www.instagram.com/intl.livebooking', domain: 'intllivebooking.it', desc: "Agenzia di booking internazionale per artisti urban. Date europee, tour e live experience. Partner booking T.P.", mode: 'text' },
    ],
  },
];

const SponsorLogoCard = ({ item }) => {
  const clickable = Boolean(item.url);
  const logoUrl = item.logo
    ? resolveMedia(item.logo)
    : (item.mode !== 'text' && item.domain ? `https://logo.clearbit.com/${item.domain}` : null);

  const inner = (
    <div className="flex flex-col rounded-xl overflow-hidden border border-gray-800 hover:border-red-600 transition-all bg-gray-900 group h-full">
      <div className={`relative ${item.logo ? 'h-28 bg-gray-950' : 'h-28 bg-white'} flex items-center justify-center p-4`}>
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={item.name}
            className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-300"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const fb = e.currentTarget.nextElementSibling;
              if (fb) fb.style.display = 'flex';
            }}
          />
        ) : null}
        <div
          className={`${logoUrl ? 'hidden' : 'flex'} absolute inset-0 items-center justify-center bg-black text-white text-center px-3`}
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1.5px' }}
        >
          <span className="text-base sm:text-lg font-bold leading-tight">{item.name}</span>
        </div>
        {clickable && (
          <span className="absolute top-2 right-2 bg-black/70 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
            <ExternalLink size={12} />
          </span>
        )}
      </div>
      <div className="p-3 flex-1 flex flex-col">
        <p className="text-white font-bold text-sm leading-tight mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
          {item.name}
        </p>
        {item.desc && <p className="text-gray-400 text-xs leading-relaxed line-clamp-3">{item.desc}</p>}
      </div>
    </div>
  );

  return clickable ? (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`sponsor-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
      className="block h-full"
    >
      {inner}
    </a>
  ) : (
    <div className="h-full">{inner}</div>
  );
};

const SponsorClientiPage = () => {
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-content/sponsors`)
      .then(r => r.json())
      .then(d => setSponsors(Array.isArray(d.items) ? d.items : []))
      .catch(() => setSponsors([]));
  }, []);

  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-7xl mx-auto">
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '3px' }}
        >
          SPONSOR E CLIENTI
        </h1>
        <div className="w-24 h-1 mx-auto mb-4" style={{ backgroundColor: 'var(--tp-red)' }} />
        <p className="text-center text-gray-400 text-sm sm:text-base max-w-2xl mx-auto mb-12">
          I partner che hanno creduto nel progetto Tecniche Perfette. Clicca su un logo per visitare il sito ufficiale.
        </p>

        {/* Main partner — loghi grandi */}
        {sponsors && sponsors.some(sp => sp.featured) && (
          <section className="mb-12 sm:mb-16" data-testid="main-partners-section">
            <h2
              className="text-2xl sm:text-3xl font-bold text-yellow-400 mb-6 flex items-center gap-3"
              style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
            >
              <span className="inline-block w-2 h-8 bg-yellow-500 rounded-sm" />
              MAIN PARTNER
            </h2>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              {sponsors.filter(sp => sp.featured).map((sp) => {
                const inner = (
                  <div className="flex flex-col items-center rounded-2xl border border-yellow-500/40 hover:border-yellow-400 bg-gray-950 px-8 sm:px-12 py-6 sm:py-8 transition-all hover:scale-[1.02] shadow-[0_0_40px_rgba(234,179,8,0.12)] min-w-[220px] sm:min-w-[300px]">
                    {sp.logo ? (
                      <img src={resolveMedia(sp.logo)} alt={sp.name} className="h-24 sm:h-32 max-w-[260px] sm:max-w-[360px] object-contain" />
                    ) : (
                      <span className="text-white text-3xl sm:text-4xl font-bold" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>{sp.name}</span>
                    )}
                    <p className="text-white font-bold mt-4 text-base sm:text-lg" style={{ fontFamily: 'Oswald, sans-serif' }}>{sp.name}</p>
                    {sp.desc && <p className="text-gray-400 text-xs sm:text-sm text-center mt-1 max-w-xs">{sp.desc}</p>}
                  </div>
                );
                const tid = `main-partner-${sp.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
                return sp.url
                  ? <a key={sp.name} href={sp.url} target="_blank" rel="noopener noreferrer" data-testid={tid}>{inner}</a>
                  : <div key={sp.name} data-testid={tid}>{inner}</div>;
              })}
            </div>
          </section>
        )}

        {/* Sponsor attuali — gestiti dall'admin (stessi loghi/link del footer) */}
        <section className="mb-12 sm:mb-16" data-testid="current-sponsors-section">
          <h2
            className="text-2xl sm:text-3xl font-bold text-red-500 mb-5 flex items-center gap-3"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
          >
            <span className="inline-block w-2 h-8 bg-red-600 rounded-sm" />
            SUPPORT & SPONSOR {new Date().getFullYear()}
          </h2>
          {sponsors === null ? (
            <div className="py-8 flex justify-center text-gray-500"><Loader2 className="animate-spin" /></div>
          ) : sponsors.length === 0 ? (
            <p className="text-gray-500 text-sm">Nessuno sponsor pubblicato al momento.</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 sm:gap-4">
              {sponsors.map((item) => (
                <SponsorLogoCard key={item.name} item={{ ...item, mode: item.logo ? 'logo' : 'text' }} />
              ))}
            </div>
          )}
        </section>

        <h2
          className="text-xl sm:text-2xl font-bold text-gray-300 mb-8 text-center tracking-widest"
          style={{ fontFamily: 'Oswald, sans-serif' }}
        >
          PARTNER & CLIENTI STORICI
        </h2>

        {SECTIONS.map((section) => (
          <section key={section.title} className="mb-12 sm:mb-16">
            <h2
              className="text-2xl sm:text-3xl font-bold text-red-500 mb-5 flex items-center gap-3"
              style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
            >
              <span className="inline-block w-2 h-8 bg-red-600 rounded-sm" />
              {section.title}
            </h2>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 sm:gap-4">
              {section.items.map((item) => (
                <SponsorLogoCard key={item.name} item={item} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default SponsorClientiPage;
